<template>
	<v-combobox
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	></v-combobox>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	props: {
		generation:	{ type: Object, default: null },
	},
	watch: {
		generation(item) {
			this.onRefresh(item)
		},
	},
	computed: {
		...mapGetters('VehicleModification', [ 'items' ]),
	},
	methods: {
		...mapActions('VehicleModification', [ 'load', 'setItems' ]),

		onLoad() {
			if(this.generation) {
				this.loading = true;
				this.load({generation: this.generation}).then(() => {
					this.setDefault();
				}).finally(() => (this.loading = false));
			}
		},
	},
}
</script>